export const FirebaseConfig = {
	"projectId": "hytchify",
	"appId": "1:621687893002:web:0e15527f64874ba6d543f3",
	"databaseURL": "https://hytchify-default-rtdb.firebaseio.com",
	"storageBucket": "hytchify.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBFgp5k1Eh6aTieD_CS4LBPd6EZQJGp8fY",
	"authDomain": "hytchify.firebaseapp.com",
	"messagingSenderId": "621687893002",
	"measurementId": "G-NK6KZMXJFD"
};